export default "__VITE_ASSET__CatwPjj8__"